/* eslint-disable */

export enum ArticleType {
  HELP_ARTICLE = "HELP_ARTICLE",
  LEGAL_PAGE = "LEGAL_PAGE",
}

export interface Article {
  id?: string;
  token?: string;
  region?: string;
  locale?: string;
  slug?: string;
  title?: string;
  body?: string;
  summary?: string;
  meta_title?: string;
  meta_description?: string;
  updated_at?: number;
  visible?: boolean;
  parent_tokens?: string[];
  child_tokens?: string[];
  redirect_token?: string;
  type?: ArticleType;
}

export interface SuggestedReplyPayload {
  reply_token?: string;
  effect?: string;
  auto_response_token?: string;
  conversation_token?: string;
}

export interface SelectTransactionActionPayload {
}
